/* Holiday effects for the Axtlan shop (365 rotation, owner F07: "special fx like in speclang.pro new page, for every mexican
 * major holiday and themed to it"). Glow sprites with additive blending, three depth layers with pointer parallax, firework
 * bloom; modes advanced (Full) / lightweight (Light) / off; prefers-reduced-motion and forced colours start Off; the loop
 * pauses when the tab is hidden or the canvas is off screen. data-fx = "<kind>:<palette>" from metaobject rotation_day.
 *
 * Owner 2026-10-06 (18:01): "The fx cannot obstruct the visibility, and should be on a intensity curve, day before the
 * holiday small amounts and unregulated, then apex through the holiday middle and fade on next day".
 *  - Never over content: particles are drawn only in the free side margins outside the page content column (.page-width);
 *    a CSS mask hides anything that drifts inwards. When the margins are narrower than 48 px (phones, small windows) the
 *    canvas stays empty. Anything else that reaches into the margins (the full-width header, logo, icons, banner images,
 *    buttons, links, embedded frames) is measured every 400 ms and kept clear with a 6 px border. pointer-events: none,
 *    alpha capped.
 *  - Intensity curve from data-fx-start (unix s, first holiday day 00:00 Merida) and data-fx-days (run length):
 *      eve  (24 h before): 0.12 -> 0.25, in irregular gusts (often nothing, then a short burst)
 *      holiday           : 0.40 at the start, 1.00 at the middle of the run, 0.40 at the end (parabola)
 *      fade (24 h after) : 0.40 -> 0
 *    Intensity scales the number of particles and their brightness; it is re-read every 2 s, so a page left open follows
 *    the curve. data-fx-now (unix s) shifts the clock for the theme editor preview.
 * Kinds: fireworks, stars, glow, snow, petals, papel-picado, confetti (flag = tricolour confetti), hearts, bubbles (rise),
 * streaks (rise fast with a light trail). Palettes below; the holiday table HOLIDAYS-AXTLAN.json picks kind:palette.
 * Canvases: canvas.rotation-today__canvas (homepage section) and canvas.ax-fx-page (fixed, every other page, from
 * sections/axtlan-experience.liquid). The sitewide switch (assets/axtlan-experience.js) sends 'ax:mode'. */
(function () {
  'use strict';
  var PALETTES = {
    gold: ['#f5c542', '#ffd97a', '#e0a526', '#fff1c1'],
    tricolor: ['#00a86b', '#ffffff', '#e2283b'],
    candle: ['#ffb347', '#ffd27f', '#ff8c1a'],
    jacaranda: ['#a07ce0', '#c9b3f0', '#8e6cc9'],
    bright: ['#ff3d8b', '#ffe14d', '#29d4ff', '#9be15d', '#ff9a3c', '#c86bff'],
    rose: ['#ff4f8b', '#ffa6c4', '#e0306e', '#ffffff'],
    chalk: ['#ffffff', '#e9e9e9', '#cfcfcf'],
    earth: ['#c49a6c', '#e0b07a', '#ffb74d', '#4db6ac'],
    cempasuchil: ['#ff8f00', '#ffa000', '#ffc233', '#ff6d00', '#b14cff'],
    pinata: ['#ff3d8b', '#ffe14d', '#3d8bff', '#4cd964', '#ff9500'],
    light: ['#ffffff', '#e3f2fd', '#bbdefb'],
    ash: ['#9e9e9e', '#bdbdbd', '#757575', '#e0e0e0'],
    navy: ['#0b3d91', '#ffffff', '#5d9cec', '#c9d8f0'],
    olive: ['#556b2f', '#8f9779', '#c2b280', '#d4af37'],
    sky: ['#87ceeb', '#ffffff', '#00a86b', '#e2283b'],
    flame: ['#ff6a00', '#ffb347', '#fff3c4', '#ff3d00'],
    white: ['#ffffff', '#f5f5f5', '#e3f2fd', '#fff8e1']
  };
  var RISING = { bubbles: 1, streaks: 1 }; // kinds that travel upwards (Navy, Saint John / Air Force)
  var KEY = 'axtlan-rotation-fx';
  var MIN_GUTTER = 48;
  var mq = function (q) { return window.matchMedia && window.matchMedia(q).matches; };
  var calm = mq('(prefers-reduced-motion: reduce)') || mq('(forced-colors: active)');
  function readMode(fallback) {
    try { var v = localStorage.getItem(KEY); if (v === 'advanced' || v === 'lightweight' || v === 'off') return v; } catch (e) {}
    return calm ? 'off' : fallback;
  }
  function saveMode(v) { try { localStorage.setItem(KEY, v); } catch (e) {} }

  // Intensity 0..1 for hour h relative to the first holiday day 00:00, run of L days.
  function curve(h, days) {
    var L = days * 24;
    if (h < -24 || h > L + 24) return 0;
    if (h < 0) return 0.12 + 0.13 * (h + 24) / 24;
    if (h <= L) { var x = (h - L / 2) / (L / 2); return 0.4 + 0.6 * (1 - x * x); }
    return 0.4 * (1 - (h - L) / 24);
  }

  var spriteCache = {};
  function sprite(color, r) { // soft radial light, cached per colour/size
    var k = color + r; if (spriteCache[k]) return spriteCache[k];
    var c = document.createElement('canvas'), s = r * 2; c.width = c.height = s;
    var g = c.getContext('2d'), grd = g.createRadialGradient(r, r, 0, r, r, r);
    grd.addColorStop(0, color); grd.addColorStop(.25, color); grd.addColorStop(1, 'rgba(0,0,0,0)');
    g.fillStyle = grd; g.fillRect(0, 0, s, s);
    return (spriteCache[k] = c);
  }

  function start(canvas) {
    var spec = (canvas.getAttribute('data-fx') || '').split(':');
    var kind = spec[0], colors = PALETTES[spec[1]] || PALETTES.bright;
    if (kind === 'flag') { kind = 'confetti'; colors = PALETTES.tricolor; }
    var ctx = canvas.getContext('2d'); if (!ctx) return;
    var page = canvas.classList.contains('ax-fx-page');
    var host = page ? null : canvas.parentElement;
    var buttons = host ? host.querySelectorAll('[data-fx-mode]') : [];
    var mode = readMode(canvas.getAttribute('data-fx-default') || 'lightweight');
    var startS = parseFloat(canvas.getAttribute('data-fx-start')) || 0;
    var days = parseFloat(canvas.getAttribute('data-fx-days')) || 1;
    var phase = canvas.getAttribute('data-fx-phase') || 'on';
    var shift = canvas.getAttribute('data-fx-now') ? parseFloat(canvas.getAttribute('data-fx-now')) * 1000 - Date.now() : 0;
    var cap = page ? 0.6 : 0.8; // brightness ceiling
    var parts = [], sparks = [], raf = 0, last = 0, visible = true, w = 0, h = 0, dpr = 1, gut = 0;
    var px = 0, py = 0, tx = 0, ty = 0; // pointer parallax
    var level = 1, gust = 1, nextGust = 0, nextLevel = 0, keep = [], nextKeep = 0;
    var KEEP = 'header, sticky-header, .header-wrapper, .announcement-bar, img, video, iframe, picture, svg, button, a, input, select, textarea, .ax-exp';

    function nowMs() { return Date.now() + shift; }
    function updateLevel(t) {
      if (t < nextLevel) return; nextLevel = t + 2000;
      level = startS ? curve((nowMs() / 1000 - startS) / 3600, days) : 1;
      if (phase === 'eve' || level < 0.26) { // unregulated: gusts with silences
        if (t >= nextGust) { gust = Math.random() < 0.4 ? 0 : 0.3 + Math.random() * 1.3; nextGust = t + 2000 + Math.random() * 5000; }
      } else gust = 1;
    }
    function base() { return kind === 'fireworks' ? (mode === 'advanced' ? 7 : 3) : (mode === 'advanced' ? 110 : 36); }
    function target() { var n = base() * level * gust; return n < 1 ? (Math.random() < n ? 1 : 0) : Math.round(n); }

    function size() {
      dpr = Math.min(window.devicePixelRatio || 1, mode === 'advanced' ? 2 : 1);
      var cr = (host || document.documentElement).getBoundingClientRect();
      w = host ? host.clientWidth : window.innerWidth; h = host ? host.clientHeight : window.innerHeight;
      canvas.width = w * dpr; canvas.height = h * dpr; ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      // free side margins = outside the content column; nothing is drawn over content
      var col = host ? host.querySelector('.page-width') : (document.querySelector('main .page-width') || document.querySelector('.page-width')), l = 0, r = 0;
      if (col) { var rr = col.getBoundingClientRect(); l = rr.left - (host ? cr.left : 0); r = (host ? cr.right : w) - rr.right; }
      gut = Math.max(0, Math.min(l, r));
      if (gut < MIN_GUTTER) { canvas.style.visibility = 'hidden'; return; }
      canvas.style.visibility = '';
      var m = 'linear-gradient(90deg,#000 0,#000 ' + (gut - 24) + 'px,transparent ' + gut + 'px,transparent calc(100% - ' + gut +
        'px),#000 calc(100% - ' + (gut - 24) + 'px),#000 100%)';
      canvas.style.webkitMaskImage = m; canvas.style.maskImage = m;
    }
    function collectKeep(t) { // content that reaches into the side margins stays clear
      if (t < nextKeep) return; nextKeep = t + 400; keep = [];
      var cr = host ? host.getBoundingClientRect() : { left: 0, top: 0 };
      var nodes = (host || document).querySelectorAll(KEEP);
      for (var i = 0; i < nodes.length; i++) {
        var r = nodes[i].getBoundingClientRect(); if (!r.width || !r.height) continue;
        if (r.width > w * .9 && r.height > h * .9) continue; // transparent full-screen overlays (preview bar, app frames)
        var x = r.left - cr.left, y = r.top - cr.top;
        if (y + r.height < 0 || y > h) continue;
        if (x < gut || x + r.width > w - gut) keep.push([x - 6, y - 6, r.width + 12, r.height + 12]);
      }
    }
    function sideX() { var x = Math.random() * (gut - 8); return Math.random() < .5 ? x : w - x; }
    function particle(first) {
      var z = [0.45, 0.75, 1][(Math.random() * 3) | 0]; // depth layer
      var p = { z: z, c: colors[(Math.random() * colors.length) | 0], x: sideX(), life: 0, ph: Math.random() * 6.28 };
      if (kind === 'fireworks') {
        p.y = h + 10; p.vx = (Math.random() - .5) * .4; p.vy = -(3.5 + Math.random() * 3) * z; p.ty = h * (.12 + Math.random() * .45);
      } else if (kind === 'stars' || kind === 'glow') {
        p.y = Math.random() * h; p.r = (kind === 'glow' ? 10 : 4) + Math.random() * (kind === 'glow' ? 14 : 6) * z;
      } else if (RISING[kind]) {
        p.y = first ? Math.random() * h : h + 40; p.vx = (Math.random() - .5) * (kind === 'streaks' ? .8 : .3);
        p.vy = kind === 'streaks' ? -(5 + Math.random() * 4) * z : -(.4 + Math.random() * .8) * z;
        p.r = kind === 'streaks' ? 40 + Math.random() * 50 * z : 3 + Math.random() * 6 * z;
      } else {
        p.y = first ? Math.random() * h : -30; p.vx = (Math.random() - .5) * .4;
        p.vy = (kind === 'snow' ? .4 : .8) + Math.random() * (kind === 'snow' ? .7 : 1.5) * z;
        p.r = (kind === 'snow' ? 2 : 5) + Math.random() * (kind === 'snow' ? 3 : 6) * z;
        p.rot = Math.random() * 6.28; p.vr = (Math.random() - .5) * .06;
      }
      if (RISING[kind]) { p.rot = 0; p.vr = 0; }
      return p;
    }
    function populate() {
      parts = []; sparks = []; nextLevel = 0; nextGust = 0; updateLevel(performance.now());
      if (kind === 'stars' || kind === 'glow') { for (var i = 0; i < base(); i++) parts.push(particle(true)); return; }
      var n = target(); for (var j = 0; j < n; j++) parts.push(particle(true));
    }
    function drawShape(p, a) {
      ctx.save(); ctx.translate(p.x + px * p.z * 18, p.y + py * p.z * 12); ctx.rotate(p.rot || 0);
      ctx.globalAlpha = a * (.55 + .45 * p.z); ctx.fillStyle = p.c;
      if (kind === 'snow') { ctx.beginPath(); ctx.arc(0, 0, p.r, 0, 6.283); ctx.fill(); }
      else if (kind === 'hearts') { var r = p.r; ctx.beginPath(); ctx.moveTo(0, r * .35); ctx.bezierCurveTo(r, -r * .4, r * .45, -r * 1.1, 0, -r * .45); ctx.bezierCurveTo(-r * .45, -r * 1.1, -r, -r * .4, 0, r * .35); ctx.fill(); }
      else if (kind === 'bubbles') { ctx.strokeStyle = p.c; ctx.lineWidth = 1.2; ctx.beginPath(); ctx.arc(0, 0, p.r, 0, 6.283); ctx.stroke(); ctx.globalAlpha *= .6; ctx.beginPath(); ctx.arc(-p.r * .35, -p.r * .35, p.r * .25, 0, 6.283); ctx.fill(); }
      else if (kind === 'streaks') { ctx.rotate(-(p.rot || 0)); var g = ctx.createLinearGradient(0, 0, -p.vx * 8, p.r); g.addColorStop(0, p.c); g.addColorStop(1, 'rgba(0,0,0,0)'); ctx.strokeStyle = g; ctx.lineWidth = 2; ctx.beginPath(); ctx.moveTo(0, 0); ctx.lineTo(-p.vx * 8, p.r); ctx.stroke(); ctx.drawImage(sprite(p.c, 6), -6, -6); }
      else if (kind === 'petals') { ctx.beginPath(); ctx.ellipse(0, 0, p.r, p.r * .5, 0, 0, 6.283); ctx.fill(); ctx.globalAlpha *= .5; ctx.drawImage(sprite(p.c, 16), -16, -16); }
      else if (kind === 'papel-picado') { ctx.fillRect(-p.r, -p.r * .7, p.r * 2, p.r * 1.4); ctx.clearRect(-p.r * .3, -p.r * .2, p.r * .6, p.r * .4); }
      else { ctx.fillRect(-p.r / 2, -p.r / 4, p.r, p.r / 2); }
      ctx.restore();
    }
    function frame(t) {
      raf = 0;
      if (mode === 'off' || !visible || document.hidden || gut < MIN_GUTTER) return;
      if (mode === 'lightweight' && t - last < 33) { raf = requestAnimationFrame(frame); return; }
      last = t; px += (tx - px) * .05; py += (ty - py) * .05;
      updateLevel(t);
      var a = cap * (0.45 + 0.55 * level), want = target();
      ctx.clearRect(0, 0, w, h);
      if (kind !== 'stars' && kind !== 'glow' && parts.length < want && Math.random() < (kind === 'fireworks' ? .02 : .25)) parts.push(particle(false));
      for (var i = parts.length - 1; i >= 0; i--) {
        var p = parts[i]; p.life++;
        if (kind === 'fireworks') {
          p.x += p.vx; p.y += p.vy;
          ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = a; ctx.drawImage(sprite(p.c, 10), p.x - 10, p.y - 10);
          if (p.y <= p.ty) {
            var count = Math.round((mode === 'advanced' ? 60 : 24) * (0.5 + 0.5 * level)), speed = (1 + Math.random() * 1.6) * Math.min(1, gut / 160);
            for (var s = 0; s < count; s++) {
              var an = 6.283 * s / count + Math.random() * .1, sp = speed * (.6 + Math.random() * .5);
              sparks.push({ x: p.x, y: p.y, vx: Math.cos(an) * sp, vy: Math.sin(an) * sp, a: 1, c: colors[(Math.random() * colors.length) | 0], r: 5 + Math.random() * 5 });
            }
            sparks.push({ x: p.x, y: p.y, vx: 0, vy: 0, a: 1, c: p.c, r: Math.min(90, gut), bloom: true });
            if (parts.length > want) parts.splice(i, 1); else parts[i] = particle(false);
          }
        } else if (kind === 'stars' || kind === 'glow') {
          if (i >= Math.max(want, 1)) continue;
          var al = .3 + .7 * Math.abs(Math.sin(p.ph + p.life * .025));
          ctx.globalCompositeOperation = 'lighter'; ctx.globalAlpha = al * a * (kind === 'glow' ? .6 : 1) * p.z;
          ctx.drawImage(sprite(p.c, Math.round(p.r)), p.x + px * p.z * 18 - p.r, p.y + py * p.z * 12 - p.r);
        } else {
          p.x += p.vx + Math.sin(p.ph + p.life * .02) * .25 * p.z; p.y += p.vy; p.rot += p.vr;
          ctx.globalCompositeOperation = 'source-over'; drawShape(p, a);
          if (p.y > h + 30 || (RISING[kind] && p.y < -p.r - 40)) { if (parts.length > want) parts.splice(i, 1); else parts[i] = particle(false); }
        }
      }
      ctx.globalCompositeOperation = 'lighter';
      for (var j = sparks.length - 1; j >= 0; j--) {
        var k = sparks[j];
        if (k.bloom) { k.a -= .04; if (k.a <= 0) { sparks.splice(j, 1); continue; } ctx.globalAlpha = k.a * .3 * a; ctx.drawImage(sprite(k.c, Math.round(k.r)), k.x - k.r, k.y - k.r); continue; }
        k.x += k.vx; k.y += k.vy; k.vy += .025; k.vx *= .99; k.a -= .012;
        if (k.a <= 0) { sparks.splice(j, 1); continue; }
        ctx.globalAlpha = k.a * a; ctx.drawImage(sprite(k.c, Math.round(k.r)), k.x - k.r, k.y - k.r);
      }
      ctx.globalAlpha = 1; ctx.globalCompositeOperation = 'source-over';
      collectKeep(t); for (var q = 0; q < keep.length; q++) ctx.clearRect(keep[q][0], keep[q][1], keep[q][2], keep[q][3]);
      raf = requestAnimationFrame(frame);
    }
    function kick() { if (!raf && mode !== 'off') raf = requestAnimationFrame(frame); }
    function setMode(m, persist) {
      mode = m; if (persist) saveMode(m);
      for (var i = 0; i < buttons.length; i++) buttons[i].setAttribute('aria-pressed', String(buttons[i].getAttribute('data-fx-mode') === m));
      if (raf) { cancelAnimationFrame(raf); raf = 0; }
      ctx.clearRect(0, 0, w, h);
      if (m !== 'off') { size(); populate(); kick(); }
    }
    for (var b = 0; b < buttons.length; b++) buttons[b].addEventListener('click', function (e) { setMode(e.currentTarget.getAttribute('data-fx-mode'), true); });
    if (host && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; kick(); }).observe(host);
    document.addEventListener('visibilitychange', kick);
    window.addEventListener('scroll', function () { nextKeep = 0; }, { passive: true });
    window.addEventListener('resize', function () { if (mode !== 'off') { size(); populate(); kick(); } });
    window.addEventListener('pointermove', function (e) { tx = e.clientX / window.innerWidth - .5; ty = e.clientY / window.innerHeight - .5; }, { passive: true });
    document.addEventListener('ax:mode', function (e) {
      var m = e.detail && e.detail.mode;
      setMode(m === 'complete' ? 'advanced' : m === 'light' ? 'lightweight' : 'off', false);
    });
    setMode(mode, false);
  }
  var all = document.querySelectorAll('canvas.rotation-today__canvas[data-fx], canvas.ax-fx-page[data-fx]');
  for (var i = 0; i < all.length; i++) start(all[i]);
})();
